<template>
  <v-list-item :to="to" :height="small ? 56 : 88" :ripple="false" class="py-0 px-4">
    <div class="d-flex justify-space-between">
      <div class="d-flex gap-3">
        <div v-if="Boolean($slots.image)" class="image-container">
          <slot name="image" />
        </div>
        <div class="content-container d-flex flex-column justify-center">
          <slot name="content" />
        </div>
      </div>
      <v-list-item-action v-if="Boolean($slots.actions)">
        <slot name="actions" />
      </v-list-item-action>
    </div>
  </v-list-item>
</template>

<script>
export default {
  props: {
    to: {
      type: Object,
      default: null
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.v-list-item {
  padding: 0;
  cursor: pointer;

  &:hover {
    background-color: var(--post-detail-10) !important;
  }

  .content-container > :deep(*) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
